import 'bootstrap';
// OR import just what we need -> Nah, use the external
// import Alert from 'bootstrap/js/dist/alert';
// import Button from "bootstrap/js/src/button.js";
// import Carousel from "bootstrap/js/src/carousel.js";
// import Collapse from "bootstrap/js/dist/collapse.js";
// import Tab from "bootstrap/js/dist/tab.js";
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
// in one go? Off course, we don't use them here - so adding it everywere as needed (cumbersome!)
// import {Collapse, Tab, Carousel, Button} from 'bootstrap';
// Nah, use the external
// import 'bootstrap/dist/css/bootstrap.min.css';
// Nah, more fun as import ->
// base styles used to be common, instead of cards now applied...
// import 'bootstrap-icons/font/bootstrap-icons.css' Nop found it -> style.scss
import "./css/style.scss";
// used to be common, instead of cards now applied
import {createTable, addNav} from "./js/commonUI.js";
import {createLijstForm, addTableElementListeners} from "./js/lijstPanel.js";
import {createDetailForm, addFormElementListeners, populateForm} from "./js/detailPanel.js";

window.dataUrl = _DATAURL_; // Defined in webpack - Why doesn't he polyfill/change global into window, even whit node:{ global:true }?

// Our Theme switcher
let theme = "original";
const themes = {};
themes[theme] = document.querySelector("#theme");
/**
 * Fetches a new theme and replaces head
 * Singleton fetch/load
 * Tells webPack and MiniCssExtractPlugin.loader how to deal with this
 * Some ESLint where not using at the moment
 * Be careful when using hot-update (hashes tend to give you multiple occurrences)
 *
 * @param newTheme as desbride within webPack
 * @return {Promise<void>}  It's async
 */
const loadTheme = async (newTheme) => {
    // eslint-disable-next-line no-console
    console.count(`change theme - ${newTheme}`);
    const themeElement = document.head.querySelector("#theme");
    if (themeElement) {
        await themeElement.remove();
    }
    if (themes[newTheme]) {
        // eslint-disable-next-line no-console
        console.log(`theme already loaded - ${newTheme}`);
        document.head.appendChild(themes[newTheme]);
        return;
    }
    if (newTheme === "original") {
        // eslint-disable-next-line no-console
        console.log(`loading theme - ${newTheme}`);
        import(/* webpackChunkName: "original" */ "./css/style.scss?original").then(() => {
            themes[newTheme] = document.querySelector("#theme");
            // eslint-disable-next-line no-console
            console.log(`loaded - ${newTheme}`);
        });
    }
    if (newTheme === "sketchy") {
        // eslint-disable-next-line no-console
        console.log(`loading theme - ${newTheme}`);
        import(/* webpackChunkName: "sketchy" */ "./css/style.scss?sketchy").then(() => {
            themes[newTheme] = document.querySelector("#theme");
            // eslint-disable-next-line no-console
            console.log(`loaded - ${newTheme}`);
        });
    }
}
// bootstrap floating button switcher
document.getElementById('switch-theme').addEventListener('click', (e) => {
    if (theme === "original") {
        theme = "sketchy";
    } else {
        theme = "original";
    }
    e.target.blur();
    loadTheme(theme).catch(e => console.error(e));
});

// Our Responsive Express Server, a cookie based on device
// we take the largest possible, if the mobile orientation changes, we already have the best one for the job available
document.cookie = 'screen=' + ('devicePixelRatio' in window ? devicePixelRatio : 1) + ',' + Math.max(screen.width, screen.height) + '; path=/';

// And now the content
const lijst = createTable();
const detail = createDetailForm();

window.addEventListener('DOMContentLoaded', () => {
    const lijstPane = document.getElementById('lijst');
    lijstPane.append(createLijstForm());
    lijstPane.appendChild(document.createElement('div')).append(lijst);
    document.getElementById('subDetail').classList.add('collapsed');
    document.getElementById('detail').firstElementChild.insertAdjacentElement('afterend',detail);
    addFormElementListeners(detail);
    populateForm(detail);
    addTableElementListeners(lijst);
    addNav();
    // first time load - better here
    loadTheme(theme).catch(e => console.error(e));
});
